<div id="main-search" class="main-search open">
  <div class="input-group">
    <input type="text" id="m-search" class="form-control" placeholder="Search . . ." [style.width]="'130px'">
    <span class="input-group-append search-btn btn btn-primary">
      <i class="feather icon-search input-group-text"></i>
    </span>
  </div>
</div>
